import { Actor, Canvas, Engine, Random, Vector } from 'excalibur';
import { getDoodleColors } from '../themes/theme';
import { toRadians } from '../utils/angles';
import { DoodleKind, drawDoodle } from '../utils/sketch';

export interface DriftingDoodleOptions {
  name: string;
  kind: DoodleKind;
  pos: Vector;
  size: number;
  toneIndex: number;
  seed: number;
  drift?: number;
  z?: number;
}

export class DriftingDoodle extends Actor {
  private readonly baseY: number;
  private readonly phase: number;
  private readonly drift: number;
  private readonly baseOpacity: number;
  private readonly kind: DoodleKind;
  private readonly size: number;
  private readonly toneIndex: number;
  private readonly seed: number;
  private readonly doodleCanvas: Canvas;
  private time = 0;

  constructor(options: DriftingDoodleOptions) {
    const canvas = new Canvas({
      width: options.size * 3,
      height: options.size * 3,
      cache: true,
      draw: (ctx) => this.paint(ctx),
    });
    super({
      name: options.name,
      pos: options.pos,
      z: options.z === undefined ? -20 : options.z,
      graphic: canvas,
    });
    this.doodleCanvas = canvas;
    this.kind = options.kind;
    this.size = options.size;
    this.toneIndex = options.toneIndex;
    this.seed = options.seed;
    this.baseY = options.pos.y;
    const rng = new Random(options.seed + 5);
    this.phase = rng.floating(0, Math.PI * 2);
    this.drift = options.drift === undefined ? 12 : options.drift;
    this.baseOpacity = rng.floating(0.45, 0.8);
    this.rotation = toRadians(rng.floating(-8, 8));
  }

  refreshTheme(): void {
    this.doodleCanvas.flagDirty();
  }

  onPreUpdate(_engine: Engine, elapsed: number): void {
    const dt = elapsed / 1000;
    this.time += dt;
    this.pos.y = this.baseY + Math.sin(this.time * 0.7 + this.phase) * this.drift;
    this.rotation = toRadians(Math.sin(this.time * 0.5 + this.phase) * 6);
    this.graphics.opacity = this.baseOpacity + Math.sin(this.time * 0.9 + this.phase) * 0.2;
  }

  private paint(ctx: CanvasRenderingContext2D): void {
    const colors = getDoodleColors();
    const color = colors[this.toneIndex % colors.length];
    drawDoodle(ctx, this.kind, this.size * 1.5, this.size * 1.5, this.size, new Random(this.seed), color, 3);
  }
}
